// extracted by mini-css-extract-plugin
var _1 = "UnderlineView__main--MHUbB";
var _2 = "UnderlineView__underline--fKKgK";
var _3 = "UnderlineView__underlineLarge--dMc_l UnderlineView__underline--fKKgK";
var _4 = "UnderlineView__underlineMedium--XavVN UnderlineView__underline--fKKgK";
var _5 = "UnderlineView__underlineSmall--QgyD7 UnderlineView__underline--fKKgK";
export { _1 as "main", _2 as "underline", _3 as "underlineLarge", _4 as "underlineMedium", _5 as "underlineSmall" }
